import React, { ReactElement } from "react";

import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

import IconSelector from "../images/IconSelector";

const GenericStatus = ({ status }: { status: string | null }): ReactElement => {
 const RenderStatusMessage = () => {
  switch (status) {
   case "online":
    return <Typography variant="caption">Online</Typography>;
   case "offline":
    return <Typography variant="caption">Offline</Typography>;
   case "expired":
    return <Typography variant="caption">Expired</Typography>;
   case "creating":
    return <Typography variant="caption">Creating</Typography>;
   case "upgrading":
    return <Typography variant="caption">Upgrading</Typography>;
   case "updating":
    return <Typography variant="caption">Updating</Typography>;
   default:
    return <Typography variant="caption">unknown</Typography>;
  }
 };

 const RenderStatus = () => {
  switch (status) {
   case "online":
    return (
     <IconSelector icon="StatusIcon" props={{ sx: { color: "#2E7D32", fontSize: "small" } }} />
    );
   case "offline":
    return (
     <IconSelector icon="ReportIcon" props={{ sx: { color: "#FF1800", fontSize: "small" } }} />
    );
   case "expired":
    return (
     <IconSelector icon="ReportIcon" props={{ sx: { color: "#FF1800", fontSize: "small" } }} />
    );
   case "creating":
    return <IconSelector icon="AddIcon" props={{ sx: { color: "#FFB600", fontSize: "small" } }} />;
   case "upgrading":
    return (
     <IconSelector icon="RestoreIcon" props={{ sx: { color: "#30D1FF", fontSize: "small" } }} />
    );
   case "updating":
    return (
     <IconSelector icon="RestoreIcon" props={{ sx: { color: "#30D1FF", fontSize: "small" } }} />
    );
   default:
    return (
     <IconSelector icon="HelpOutlineIcon" props={{ sx: { color: "grey", fontSize: "small" } }} />
    );
  }
 };

 const renderStyle = () => {
  switch (status) {
   case "online":
    return {
     color: "#2E7D32",
     border: "1px solid #2E7D32",
     backgroundColor: "rgba(46, 125, 50, 0.2)",
     fontWeight: "bold",
     pl: 1
    };
   case "offline":
    return {
     color: "#FF1800",
     border: "1px solid #FF1800",
     backgroundColor: "rgb(255, 24, 0, 0.2)",
     fontWeight: "bold",
     pl: 1
    };
   case "expired":
    return {
     color: "#FF1800",
     border: "1px solid #FF1800",
     backgroundColor: "rgb(255, 24, 0, 0.2)",
     fontWeight: "bold",
     pl: 1
    };
   case "creating":
    return {
     color: "#FFB600",
     border: "1px solid #ffb600",
     backgroundColor: "rgb(255, 182, 0, 0.2)",
     fontWeight: "bold",
     pl: 1
    };
   case "upgrading":
    return {
     color: "#30D1FF",
     border: "1px solid #30D1FF",
     backgroundColor: "#E0F8FF",
     fontWeight: "bold",
     pl: 1
    };
   case "updating":
    return {
     color: "#30D1FF",
     border: "1px solid #30D1FF",
     backgroundColor: "#E0F8FF",
     fontWeight: "bold",
     pl: 1
    };
   default:
    return {
     color: "#grey",
     border: "1px solid grey",
     backgroundColor: "lightgray",
     fontWeight: "bold",
     pl: 1
    };
  }
 };

 return (
  <Chip label={<RenderStatusMessage />} sx={renderStyle()} size="small" icon={<RenderStatus />} />
 );
};

export default GenericStatus;
